/**
 * 补打卡异常数据单页信息
 */
import './repairClockIn.less';

import React, { Component } from 'react';
import { Container } from 'flux/utils';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import InfoCard from '../../components/InfoCard/InfoCard.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import ConfirmButton from '../../components/ConfirmButton/ConfirmButton.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import ErrorBox from '../../components/Alert/ErrorBox.jsx';
import Button from '../../components/Button/Button.jsx';
import Form from '../../components/Form/Form.jsx';
import PageOpener from '../../components/PageOpener/PageOpener.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';

class RepairClockInEmpViewRecord extends Component {
    static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}
    constructor(props){
        super(props);
        this.commitApply = this.commitApply.bind(this);
        var id = this.props.routeParams.id;
        RepairClockInDataUtils.getEmpRciExDetail(id);
    }
    render(){
        const {
            submitting = false,
            record = {},
            status = 'loading',
            rciForm,
            refreshList
        } = this.state;

       let info = {
                'title': getLang('RCI_VIEW_INFO'),
                'items': []
       };

       //添加成功
       if (refreshList) {
           window.location.href='#/my-rci/list';
       }

        //自定义列表
        // info.items.push({
        //     firField: getLang('RCI_INFO_TYPENAME'),
        //     secField: record.att_exe_typname
        // });
        // info.items.push({
        //     firField: getLang('RCI_INFO_CTIME'),
        //     secField: record.att_exe_ctime
        // });
        // info.items.push({
        //     firField: getLang('RCI_INFO_ETIME'),
        //     secField: record.att_exe_gtime
        // });
        // info.items.push({
        //     firField: getLang('RCI_INFO_EXEDESC'),
        //     secField: record.att_exe_resdesc
        // });
        // info.items.push({
        //     firField: getLang('RCI_INFO_LV'),
        //     secField: record.att_exe_lv
        // });
        // info.items.push({
        //     firField: getLang('RCI_INFO_LE'),
        //     secField: record.att_exe_le
        // });

       return (<div><Header goBack title={getLang('RCI_VIEW_DATA')} />
                <Loader status={status} ></Loader>
                <div><h2 className="info-card-heading gap-b">{info.title}</h2>
					<InfoCard items={record.appInfo} />
				</div>
                <div>
                    {/*<textarea placeholder={getLang('RCI_REASON_REMARK')} className='input-rci-reason' ref='txtReason' />
                    <ErrorBox ref='errorBox' />*/}
                    <Button type='button' text={getLang('COMMIT_APPLY')} onClick={this.commitApply} />
				</div>

                <PageOpener ref='apply'>
					<Loader status={status}>
						<Form className='side-gap pad-b'
									controls={rciForm}
									ref='applyForm' />
						<div className="row">
							<div className="col-1-2">
								<Button type='button'
									disabled={submitting}
									text={getLang('SAVE')} onClick={this.insert.bind(this, false)} />
							</div>
							<div className="col-1-2">
								<Button type='button'
									disabled={submitting}
									text={getLang('SUBMIT')} onClick={this.insert.bind(this, true)} />
							</div>
						</div>
					</Loader>
				</PageOpener>
      </div>);
    }

    /**
     * 提交申请
     */
    commitApply(e) {
        this.refs.apply.open(e);
        this.url = '/ess-insert-repair-timeclock';

		RepairClockInDataUtils.getRciApplyForm();
        
        //let $reason = React.findDOMNode(this.refs.txtReason);
        // if($reason.value == ''){
        //     this.refs.errorBox.setState({message:'请输入原因或备注'});
        //     return;
        // }else{
            //提交申请并跳转
            //alert('执行跳转');
            //window.location.hash = '#/my-rci/';
        //}
        
		// OvertimeDataUtils.revokeRecord({
		// 	id: this.props.routeParams.id,
		// 	onRevoke: this.state.empOtRecord.onRevoke
		// });
	}

    /**
	 * 新增表单
	 * - save: { submit: false}
	 * - submit: { submit: true }
	 * @param submitValue
	 */
	insert(submitValue, e) {
		const formData = this.collectFormData(submitValue);

		if (!formData) return;

		RepairClockInDataUtils.empRciApplyInsert(formData, this.url);

		e.preventDefault();
	}

    /**
	 * 若表单合法, 返回 formData
	 * 若不合法, 返回 false
	 * @param {boolean} submitValue
	 * @returns {boolean|*}
	 */
	collectFormData(submitValue) {
		const form = this.refs.applyForm,
			formData = new FormData(React.findDOMNode(form));

		if (!form.isValid() || window.leaveValidation && !window.leaveValidation()) return;

		formData.append('submit', submitValue);

		formData.append('verify', false);

		if (this._editId) {
			formData.append('id', this._editId);
		}

		return formData;
	}
}

export default Container.create(RepairClockInEmpViewRecord);



// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInEmpViewRecordContainer.js